import React, { useState } from "react"
import { sendProfileConfirmation } from "../../../common/api/products"

import './profile-confirmation.scss'
import { CloseIcon } from '../../../common/components/svgs/CloseIcon';
import { SuccessIcon } from '../../../common/components/svgs/SuccessIcon';

export interface ProfileConfirmationEmailSentProps {
  profileConfirmationId: string;
  email: string;
  onClose: () => void;
  onEdit: () => void;
}

export const ProfileConfirmationEmailSent = (props: ProfileConfirmationEmailSentProps) => {
  const [isResent, setIsResent] = useState(false);

  const resendEmail = () => {
    setIsResent(true);
    sendProfileConfirmation(props.profileConfirmationId);
  }  

  return (
    <div className="container profile-confirmation">
        <CloseIcon onClick={props.onClose} id="close-btn" data-testid="close-btn" className="close" width="23px" height="23px" />

        <h2 className="margin-top-20">Email Sent!</h2>
        <p className="margin-top-20">
            An email has been sent to:
            <br/>
            <strong>{props.email}</strong>
            <button onClick={props.onEdit} className="btn-link" style={{marginLeft: "10px"}}>edit this email</button>
        </p>
        <p className="margin-top-30">Click the link in the email to confirm you received it.</p>

        <h3 className="margin-top-50">Not seeing it?</h3>
        <p>
          Check your spam filters. The email was sent from <strong>NavisphereAccount@chrobinson.com</strong>.
          <br/><br/>
          Or
          <br/><br/>
          { isResent 
            ? <span> <SuccessIcon style={{verticalAlign: "middle"}} fill="#7b9f1b" width="14px" height="14px"/> Email sent again </span>
            : <button onClick={resendEmail} className="btn-link">Resend it</button>
          }
        </p>
    </div>
  );
}

